<template>
  <div class="modal fade slide-right" id="hotlineModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-sm modal-payment" style="width: 35%;">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="$emit('cancel')">
                        <i class="pg-close fs-14"></i>
                      </button>

                  </div>
                  <div class="modal-body"  >
                      <div class="col-md-12 modal-right">
                        <h4>Création d'un message</h4>
                        <p>Merci de vérifier l'exactitude des informations ci-dessous.<br>Une fois enregistré, ce message ne pourra ni être modifié, ni être supprimé.</p>

                        <h5>Client</h5>
                        <p>
                          <span v-if="dataToSend.related_customer && dataToSend.customer_id">{{ dataToSend.related_customer.name }}</span>
                        </p>

                        <h5>Contrat</h5>
                        <p>{{ dataToSend.contract.order.ihrez }} ({{ dataToSend.contract.offer.distributed_product.agency.name }})</p>

                        <h5>Détails du message</h5>
                        <p>
                          <strong>Date et heure de réception : </strong>
                          <span v-if="dataToSend.params.calling_date">{{ dataToSend.params.calling_date | moment-date-time }}</span>
                        </p>
                        <p>
                          <strong>Société : </strong>
                          <span v-if="dataToSend.params.company">{{ dataToSend.params.company }}</span>
                        </p>
                        <p>
                          <strong>Prénom et nom : </strong>
                          <span v-if="dataToSend.params.contact">{{ dataToSend.params.contact }}</span>
                        </p>
                        <p>
                          <strong>Email : </strong>
                          <span v-if="dataToSend.params.email">{{ dataToSend.params.email }}</span>
                        </p>
                        <p>
                          <strong>Téléphone : </strong>
                          <span v-if="dataToSend.params.email">{{ dataToSend.params.phone }}</span>
                        </p>

                        <h5>Message</h5>
                        <p v-if="dataToSend.params.message">{{ dataToSend.params.message }}</p>
                        <p v-else>Aucun message renseigné</p>
                      </div>
                    </div>
                  <div class="modal-footer">
                    <button class="btn btn-default" @click="$emit('cancel', false)">
                      <span>Annuler</span>
                    </button>
                    <button class="btn btn-complete sm" @click="sendDatas">
                      <span>Confirmer</span>
                    </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import {mapState, mapActions} from "vuex"
import cookies from "cookiesjs"

export default {
  name:"HotlineModal",

  props:["dataToSend"],

  mounted() {
    $(this.$el).modal()
  },

  beforeDestroy() {
    $(this.$el).modal('hide')
    $('body').removeClass('modal-open')
    $('.modal-backdrop').remove()
  },

  methods:{
    ...mapActions("hotline", ["create_hotline_message"]),

    sendDatas() {
      this.create_hotline_message(this.dataToSend)
          .then((response) => this.$emit('success', false))
    },
  },

}
</script>
<style scoped>
  .missing_datas {
    color:red;
  }

  h5 {
    margin-top: 20px;
  }

  p {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// client/components/Hotline/Modal.vue